<template>
    <TariffNotificationModal
        ref="modalRef"
        title="Важно"
        :button-text="buttonText"
        secondary-button-text="Оставить паузу"
        :max-width="450"
        @button-click="onResume"
        @secondary-button-click="onCancel"
    >
        <template #default>
            <p class="resume-important__text" :class="{ 'mb-0': !showAutoPaymentText }">
                Если вы возобновите подписку сейчас, повторно взять паузу не получится.
                Заморозка PRO доступна только 1 раз в календарный год.
            </p>
            <p v-if="showAutoPaymentText" class="resume-important__text mb-0">
                {{ paymentText }}
            </p>
        </template>
    </TariffNotificationModal>
</template>

<script setup lang="ts">
import TariffNotificationModal from '@/components/TariffNotificationModal.vue';
import { computed, ref } from 'vue';

const props = withDefaults(defineProps<{
    // Активен ли ещё оплаченный период PRO (оплаченное время не закончилось)
    hasActivePaidPeriod?: boolean;
    // Есть сохранённая карта. Без неё (удалили, FINCH-2543) оплата идёт через форму банка
    hasPaymentData?: boolean;
}>(), {
    hasActivePaidPeriod: false,
    hasPaymentData: true,
});

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

// Если оплаченный период ещё идёт — списания сейчас не будет, поэтому
// текст про авто-оплату скрываем, а кнопку называем «Возобновить»
const showAutoPaymentText = computed(() => !props.hasActivePaidPeriod);
const paymentText = computed(() => (props.hasPaymentData
    ? 'Оплата произойдёт автоматически в ближайшее время.'
    : 'Вы перейдёте на страницу банка для оплаты. Карта сохранится для следующих списаний.'));
const buttonText = computed(() => (props.hasActivePaidPeriod ? 'Возобновить' : 'Оплатить'));

const emit = defineEmits<{
    (e: 'resume'): void;
    (e: 'cancel'): void;
}>();

function onResume() {
    emit('resume');
    hideModal();
}

function onCancel() {
    emit('cancel');
    hideModal();
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.resume-important__text {
    font-size: 14px;
    margin-bottom: 1rem;
}
</style>

